import { findIndex } from 'lodash'
const initialState = {
  inWaterBath: false,
  inFreezer: false,
  count: 0,
  tubes: [null,null,null,null,null,null,null,null],
  // tubes: [],
  held: false,
  controlsVisible: false,
  showToolTipControls: false,
};

// export default (state = initialState, action) => {
  export default (state = initialState, action) => {
    let currentFloatingTubeRack;
    let protocolSection = state.protocolSection;

    if (action.payload === undefined) {
        return state;
    }

    if (action.type !== "CREATE_FLOATING_TUBE_RACK" && !action.type.includes("@redux")) {
        if(action.payload.hasOwnProperty("id")){
            if(state.protocolSection.scene.apparatus.hasOwnProperty("floatingTubeRack")){
              // currentFloatingTubeRack = state.protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.protocolSection.scene.apparatus.floatingTubeRack, { id: action.payload.id })]
              // check with the above line, remove hardcoding of id
              currentFloatingTubeRack = state.protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.protocolSection.scene.apparatus.floatingTubeRack, { id: 1 })]

            }
        }
    }
    switch (action.type) {
      case 'CREATE_FLOATING_TUBE_RACK':

        //Create new obj from template state
        let newObj = { ...initialState, ...action.payload.props }

        if(protocolSection.scene.apparatus.hasOwnProperty("floatingTubeRack")){
          protocolSection.scene.apparatus.floatingTubeRack = [ ...protocolSection.scene.apparatus.floatingTubeRack, newObj ]
        } else {
          protocolSection.scene.apparatus.floatingTubeRack = [newObj]
        }

        return { ...state, ...{
          protocolSection: protocolSection
        } }

    case "SHOW_TOOL_TIP_CONTROLS_FLOATING_TUBE_RACK":
      //Payload = {containsGel}
      currentFloatingTubeRack.showToolTipControls = action.payload.showToolTipControls;

      protocolSection.scene.apparatus.floatingTubeRack[
        findIndex(protocolSection.scene.apparatus.floatingTubeRack, {
          id: action.payload.id,
        })
      ] = currentFloatingTubeRack;
      return {
        ...state,
        ...{ floatingTubeRack: protocolSection.scene.apparatus.floatingTubeRack },
      };

    case "TUBE_IN_WATER_BATH":
      //Payload = {inWaterBath}
      currentFloatingTubeRack.inWaterBath = action.payload.inWaterBath;
      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack
      return { ...state, ...{ protocolSection: protocolSection } }

    // case "TUBE_IN_FREEZER":
    //   //Payload = {inFreezer}

    //   return { ...state, ...{ inFreezer: action.payload.inFreezer } };

    case "ADD_TUBE_TO_RACK":
      // console.log('case "ADD_TUBE_TO_RACK":');
      // console.log(currentFloatingTubeRack);
      // console.log(action);
      //Payload = {type,id}
      if (currentFloatingTubeRack.count > 8) {
        //Can only hold 4 tubes
        return state;
      }

      //if 3 or less, add to rack
      let tempArr = currentFloatingTubeRack.tubes;

      //Payload includes solution's type and id
      for(var i = 0; i < tempArr.length; i++){
        if(tempArr[i] === null){
          tempArr[i] = {
            type: action.payload.type,
            solution: action.payload.solution,
            id: action.payload.id
          }
          break;
        }
      }

      currentFloatingTubeRack.count++;
      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "REMOVE_TUBE_FROM_RACK":
      //Payload = {}

      if(currentFloatingTubeRack.tubes[action.payload.index] !== null){
        currentFloatingTubeRack.tubes[action.payload.index] = null;
        --currentFloatingTubeRack.count;
      }

      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      // if(state.tubes[action.payload.index] !== null){
      //   state.tubes[action.payload.index] = null;
      //   --state.count;
      // }

      // return state;

    case "REMOVE_TUBES_FROM_RACK":
      //Payload = {}
      currentFloatingTubeRack.tubes = []
      currentFloatingTubeRack.count = 0

      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

      return { ...state, ...{
        protocolSection: protocolSection
      } }


      // return { ...state, ...{ tubes: [], count: 0 } };

    case 'SET_FLOATING_TUBE_RACK_HELD':
      currentFloatingTubeRack.held =  action.payload.held
      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

      return { ...state, ...{
        protocolSection: protocolSection
      } }

        // return { ...state, ...{ held: action.payload.held } }

    case 'SET_FLOATING_TUBE_RACK_CONTROLS_VISIBLE':

      currentFloatingTubeRack.controlsVisible =  action.payload.controlsVisible
      protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      //  return { ...state, ...{ controlsVisible: action.payload.controlsVisible} }

    //  case 'HIDE_ALL_CONTROLS':
    //   console.log('hide all controls case in ftr: ', action);
    //   console.log('currentFloatingTubeRack case in ftr: ', currentFloatingTubeRack);
    //   currentFloatingTubeRack.controlsVisible =  false;
    //   protocolSection.scene.apparatus.floatingTubeRack[findIndex(state.floatingTubeRack, { id: action.payload.id })] = currentFloatingTubeRack

    //   return { ...state, ...{
    //     protocolSection: protocolSection
    //   } }

      //  return { ...state, ...{ controlsVisible: false } }

    // case "UNDO":
    //   //Payload = {lastState}
    //
    //   if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('floatingTubeRack')) {
    //
    //     protocolSection.scene.apparatus.floatingTubeRack = action.payload.lastState.scene.apparatus.floatingTubeRack
    //
    //     return { ...state, ...{
    //       protocolSection: protocolSection
    //     } }
    //
    //   } else {
    //     return state;
    //   }

    default:
      return state;
  }
};
